import { createContext, useState, useEffect } from "react";
import { adminApi, orderApi, productApi, sellerApi } from "./utils/Api";
import axios from "axios";
import { message } from "antd";

export const UserContext = createContext();

const ContextProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [sidebar, setSidebar] = useState(false);
  const [loading, setLoading] = useState(true);
  const [tagData, setTagData] = useState([]);
  const [sellerType, setSellerType] = useState([])
  const [countries, setCountries] = useState([]);
  const [state, setStates] = useState([]);
  const [city, setCity] = useState([]);
  const [notificationData, setNotificationData] = useState([]);
  const [categories, setCategories] = useState()
  useEffect(() => {
    const handleResize = () => {
      setSidebar(window.innerWidth < 1000);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const fetchUser = async () => {
    try {
      const response = await sellerApi.get("/api/seller/getSellerByIdBYtoken", {
        withCredentials: true,
      });



      setUser(response.data.response[0]);
    } catch (error) {
      console.error("Error fetching user:", error.response?.data);

      if (error.response?.status === 401) {
        // Try refreshing token
        await getRefreshToken();
      } else {
        setUser(null);
      }
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {
    const auth = localStorage.getItem("auth")
    if (auth) {
      fetchUser();
    }
  }, [])

  const getRefreshToken = async () => {
    try {
      const response = await sellerApi.get("api/seller/refreshToken");

      if (response.data.message === "Access token refreshed successfully") {
        await fetchUser();
      }
    } catch (error) {
      console.log(error);
    }
  };


  const logout = async () => {
    try {
      const response = await sellerApi.post("api/seller/logout");
      if (response.status === 200) {
        setUser(null);


        return {
          success: true
        }
      }

    } catch (error) {

      return {
        success: false,
        message: error
      }
    }
  }

  // categories

  const getCategories = async () => {
    try {
      const response = await productApi.get("/api/category/getCategories");

      console.log(response);
      setCategories(response?.data?.data)
    } catch (error) {
      console.log(error)
    }
  }


  // country fetching

  const countryFetch = async () => {
    try {
      const response = await adminApi.get("api/countryList");

      setCountries(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  // state fetch on countryId

  const stateFetch = async (countryId) => {
    try {
      setStates([]);
      const response = await adminApi.get(
        `api/getStateByCountryId?countryId=${countryId}`
      );

      setStates(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  // city fetch on stateId
  const cityFetch = async (stateId) => {
    try {
      const response = await adminApi.get(
        `api/getCityByState?stateId=${stateId}`
      );
      setCity(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    countryFetch();
  }, []);

  // product fetch

  const [product, setProducts] = useState([]);

  const productFetch = async (page, size) => {
    try {
      const response = await productApi.get(
        `api/product/ProdbySellerWithPagination?sellerId=${user.sellerId}&page=${page}&limit=${size}`
      );

      console.log(response)
      setProducts(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  // get product by id

  const getProductsById = async (id) => {
    try {
      const response = await productApi.get(
        `api/product/getProductById?productId=${id}`
      );

      return response.data.data;
    } catch (error) {
      console.log(error)
    }
  };

  // notificationData 

  const getNotification = async () => {
    try {
      const response = await sellerApi.get(`api/notification/getNotification?sellerId=${user?.sellerId}`);


      setNotificationData(response?.data?.data)
    } catch (error) {
      console.log(error)
    }
  }


  const getDataFromPincode = async (id) => {
    try {
      const response = await axios.get(`https://api.postalpincode.in/pincode/${id}`);
      return response.data
    } catch (error) {
      console.log(error)
    }
  }






  // fecth tags 

  const tagfetch = async () => {
    try {
      const response = await adminApi.get("/api/data/getData");

      setTagData(response?.data.tags);
      setSellerType(response?.data.sellerType)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (user !== null) {
      productFetch(1, 10);
      getNotification()
    }
  }, [user]);

  useEffect(() => {
    tagfetch();
    getCategories()
  }, [])




  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        sidebar,
        setSidebar,
        countries,
        setCountries,
        state,
        setStates,
        stateFetch,
        city,
        setCity,
        cityFetch,
        productFetch,
        product,
        getProductsById,
        fetchUser,
        tagData,
        sellerType,
        logout,
        notificationData,
        getDataFromPincode,
        categories

      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default ContextProvider;
